import React, { Component } from 'react';
import SigninForm from '../../../widgets/account/SigninForm';
import { Col, Container, Row } from 'reactstrap';
import Pageheading from '../../../widgets/Pageheading';
import Logo2 from '../../../assets/images/fallandi/Fallandi_logo_login.png'
class SignIn2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div>
        {/*hero section start*/}
        <section className="position-relative">
          <Pageheading foldername={"Account"} title={"Login"} />

        </section>
        {/*hero section end*/}
        {/*body content start*/}
        <div className="page-content">
          {/*login start*/}
          <section>
            <Container>
              <Row className="align-items-center">
                <Col className="col-lg-7 col-12">
                  <img src={Logo2} className="mx-auto" alt="..." style={{ maxWidth: "300px" }} />
                </Col>
                <Col className="col-lg-5 col-12">
                  <SigninForm />
                </Col>
              </Row>
            </Container>
          </section>
          {/*login end*/}
        </div>
        {/*body content end*/}
      </div>
    );
  }
}

export default SignIn2;